import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { SvgIconsModule } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { SharedComponentGenericModule } from '@tekman/shared/component/generic';
import { SharedComponentModule } from '@tekman/shared/component/shared';
import { SharedUtilsModule, svgIcons } from '@tekman/shared/utils';
import { NgxPaginationModule } from 'ngx-pagination';
import { ConcealablePanelComponent } from './component/concealable-panel/concealable-panel.component';
import { DropdownSelectorComponent } from './component/dropdown-selector/dropdown-selector.component';
import { OverviewTableComponent } from './component/overview-table/overview-table.component';
import { RenderStatementComponent } from './component/statement/render-statement.component';
import { StatementComponent } from './component/statement/statement.component';
import { academicYearSplitPipe } from './pipes/academic-year-split.pipe';
import { isExercisePipe, isResourcePipe } from './pipes/category.pipe';
import { featurePipe } from './pipes/feature.pipe';
import { isTestYourselfPipe } from './pipes/test-yourself.pipe';
import { OverviewTableService } from './service/overview-table.service';
import { StatementEventsService } from './service/statement-events.service';
import { PaginationComponent } from './component/pagination/pagination.component';
import { ExerciseStatusComponent } from './component/excercise-status/exercise-status.component';
import { TaskItemComponent } from './component/task-item/task-item.component';
import { TaskDropdownComponent } from './component/task-dropdown/task-dropdown.component';
import { MatTooltip } from '@angular/material/tooltip';
import { StudentProgressComponent } from './component/pagination/student-progress/student-progress.component';
import { TeacherSettingsComponent } from './component/pagination/teacher-settings/teacher-settings.component';

const pipes = [isResourcePipe, isTestYourselfPipe, isExercisePipe, featurePipe, academicYearSplitPipe];

@NgModule({
  imports: [
    CommonModule,
    SvgIconsModule.forChild(svgIcons),
    TranslateModule,
    SharedComponentModule,
    FormsModule,
    DragDropModule,
    MatMenuModule,
    RouterModule,
    NgxPaginationModule,
    SharedUtilsModule,
    SharedComponentGenericModule,
    MatTooltip,
  ],
  declarations: [
    ConcealablePanelComponent,
    DropdownSelectorComponent,
    PaginationComponent,
    StatementComponent,
    RenderStatementComponent,
    OverviewTableComponent,
    ExerciseStatusComponent,
    TaskItemComponent,
    TaskDropdownComponent,
    ...pipes,
    StudentProgressComponent,
    TeacherSettingsComponent,
  ],
  exports: [
    ConcealablePanelComponent,
    DropdownSelectorComponent,
    StatementComponent,
    OverviewTableComponent,
    PaginationComponent,
    ...pipes,
    TaskItemComponent,
    TaskDropdownComponent,
    StudentProgressComponent,
  ],
  providers: [StatementEventsService, OverviewTableService],
})
export class OnmatComponentActivitiesModule {}
